export function initializeSearchToggle() {
    const searchTogglers = document.querySelectorAll('.search-menu-item');
    const searchForm = document.getElementById('searchbar-container');

    searchTogglers.forEach(item => {
        item.setAttribute('aria-expanded', 'false');

        item.addEventListener('click', () => {
            searchForm.classList.toggle('search-form--active');
            item.classList.toggle('is-opened');

            console.log(item.getAttribute("aria-expanded"));

            if(item.getAttribute("aria-expanded") === "true") {
                item.setAttribute("aria-expanded", "false")
            } else {
                item.setAttribute("aria-expanded", "true")
            }
        });
    });
}
